import React, { ReactNode, useEffect, useState } from 'react'

import { animated, useTransition } from '@react-spring/web'
import classNames from 'classnames'

import { CommonHorizontalArrow1Icon } from '@local/assets/icons'

import Clickable from '../Clickable'
import styles from './index.module.scss'
import ToastIcon, { ToastIconType } from './ToastIcon'

export interface ToastProps {
  top?: number
  type2Row?: boolean
  title: ReactNode
  text?: ReactNode
  btnName?: string
  btnProps?: Omit<Parameters<typeof Clickable>[0], 'children'>
  iconType?: ToastIconType
  hideTime?: number
}

const Toast = ({ top, type2Row, title, text, btnName, btnProps = {}, iconType, hideTime = 2000 }: ToastProps) => {
  const [showTarget, setShowTarget] = useState(true)
  const transitions = useTransition(showTarget, getTransitionStyle(top))

  useEffect(() => {
    const timerId = window.setTimeout(() => {
      setShowTarget(false)
    }, hideTime)

    return () => window.clearTimeout(timerId)
  }, [hideTime])

  return transitions(
    (style, show) =>
      show && (
        <animated.div className={styles.toast_area} role="alert" style={style as any}>
          <div className={classNames(styles.inner_area, { [styles.type_2row]: type2Row, [styles.type_nx]: false })}>
            <ToastIcon type={iconType} />
            <div className={styles.info_area}>
              <div className={styles.tit_area}>{title}</div>
              {text && <div className={styles.txt_area}>{text}</div>}
            </div>
            {btnName && (
              <div className={styles.btn_area}>
                <Clickable className={styles.btn} {...btnProps}>
                  {btnName}
                </Clickable>
                {/* 아직 더보기 케이스 없음 */}
                {false && (
                  <Clickable className={styles.btn_arrow}>
                    <CommonHorizontalArrow1Icon className={styles.icon} aria-hidden="true" />
                    <span className="place_blind">더보기</span>
                  </Clickable>
                )}
              </div>
            )}
          </div>
        </animated.div>
      ),
  )
}

const getTransitionStyle = (top?: number) => {
  if (top === undefined)
    return {
      config: {
        tension: 300,
        clamp: true,
      },
      from: { opacity: 0, bottom: -20 },
      enter: { opacity: 1, bottom: 0 },
      leave: { opacity: 0, bottom: -20 },
    }

  return {
    config: {
      tension: 300,
      clamp: true,
    },
    from: { opacity: 0, top: top === 0 ? -20 : -top * 2 },
    enter: { opacity: 1, top },
    leave: { opacity: 0, top: top === 0 ? -20 : -top * 2 },
  }
}

export default Toast
